<template>
    <g>
        <line
            v-bind="{
                class : 'tool_svgElem',
                id  : tool.id + '-body',
                x1  : tool.coords.pts[0].x, 
                y1  : tool.coords.pts[0].y,
                x2  : tool.coords.pts[1].x,   
                y2  : tool.coords.pts[1].y,
            }" 
        />
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { tools } from '../../mixins/tools';

// =========================================================================================

export default {
    name : 'retaCMP',

    mixins: [tools],

    data () {
        return {
        }
    },

    computed: {
    },

    methods: {
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>